import { route } from "./apiRoutes";
import { POST } from "./axiosInstance";

/**
 * Compress image using the compression API
 * @param {File} file - The image file to compress
 * @param {number} width - Target width for compression
 * @param {number} height - Target height for compression
 * @returns {Promise} - Promise resolving to compression result
 */
export const compressImageAPI = async (file, width = 800, height = 600) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('width', width.toString());
    formData.append('height', height.toString());
   

    // Replace '/api/compress-image' with your actual compression API endpoint
    const response = await POST(route.COMPRESS_IMAGE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response.response.data, // Base64 string of compressed image
        filename: response.response.filename, // New filename from compression service
        
      };
    } else {
      throw new Error('Compression API returned invalid response');
    }
  } catch (error) {
    console.error('Image compression failed:', error);
    throw new Error(error?.response?.data?.message || 'Image compression failed');
  }
};

/**
 * Fallback client-side compression using Canvas API
 * This is a basic implementation for when the server-side compression is not available
 */
export const compressImageClientSide = (file, maxWidth = 800, maxHeight = 600, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      // Calculate new dimensions
      let { width, height } = img;
      
      if (width > height) {
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;

      // Draw and compress
      ctx.drawImage(img, 0, 0, width, height);
      
      canvas.toBlob(
        (blob) => {
          if (blob) {
            const reader = new FileReader();
            reader.onload = () => {
              resolve({
                success: true,
                data: reader.result.split(',')[1], // Base64 without data URL prefix
                filename: file.name,
              
              });
            };
            reader.onerror = () => reject(new Error('Failed to read compressed image'));
            reader.readAsDataURL(blob);
          } else {
            reject(new Error('Canvas compression failed'));
          }
        },
        'image/jpeg',
        quality
      );
    };

    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = URL.createObjectURL(file);
  });
};